import React, {useState, useEffect, useRef, useMemo} from 'react';
import {object, bool, func, number} from 'prop-types';
import {
    DatePickerCustom,
    InputEntidad,
    InputLista,
    Loading,
    MessageModal,
    ProcessLoading,
    TableCustom,
    Accordion,
    Select
} from '../../common';
import {CloneObject} from '../../../utils/helpers';
import {APIS} from '../../../config/apis';
import { ALERT_TYPE, APROBACION_STATE, AvanceProceso, EMISION_EJECUCION_STATE, PROCESO_STATE, REQUEST_METHOD, ShowToastMessage, formatAvanceProceso } from '@laramie/ui';
import {ServerRequest} from '../../../utils/apiweb';
import ProcesoModal from '../ProcesoModal';
import {EncodeTo64, getDateNow, getDateSerialize, getDateToString} from '../../../utils/convert';
import {useLista} from '../../hooks/useLista';
import {useAccess} from '../../hooks/useAccess';
import {APPCONFIG} from '../../../app.config';
import ProrrogaSeleccionModal from '../ProrrogaSeleccionModal';
import NotificacionSeleccionModal from '../NotificacionSeleccionModal';
import {isEmptyString} from '../../../utils/validator';
import { usePermissions } from '../../hooks';
import { PERMISSIONS } from '../../../consts/permissions';


const EmisionProcesosGrid = (props) => {

    const procesoInit = {
        id: 0,
        identificador: "",
        entidad: "",
        idEntidad: 0,
        idProcesoProgramacion: 0,
        idEstadoProceso: 0,
        idCategoriaProceso: 0,
        idTipoProceso: 0,
        fechaProceso: null,
        fechaInicio: null,
        fechaFin: null,
        descripcion: "",
        observacion: "",
        avance: 0,
        origen: "",
        idUsuarioCreacion: "",
        fechaCreacion: null,
        urlEjecucion: "",
        temporal: false,
        cancelacionSolicitada: false,
        cancelable: false,
        pausable: false
    }

    const aprobaciontInit = {
        id: 0,
        idEmisionEjecucion: 0,
        idEstadoProcesoInformeCalculo: 0,
        idUsuarioProcesoInformeCalculo: 0,
        fechaProcesoInformeCalculo: null,
        idEstadoProcesoControlRecibos: 0,
        idUsuarioProcesoControlRecibos: 0,
        fechaProcesoControlRecibos: null,
        idEstadoAprobacionCalculo: 0,
        idUsuarioAprobacionCalculo: 0,
        fechaAprobacionCalculo: null,
        idEstadoAprobacionControlRecibos: 0,
        idUsuarioAprobacionControlRecibos: 0,
        fechaAprobacionControlRecibos: null,
        idEstadoProcesoOrdenamiento: 0,
        idUsuarioProcesoOrdenamiento: null,
        fechaProcesoOrdenamiento: null,
        idEstadoProcesoInformeOrdenamiento: 0,
        idUsuarioProcesoInformeOrdenamiento: null,
        fechaProcesoInformeOrdenamiento: null,
        idEstadoAprobacionOrdenamiento: 0,
        idUsuarioAprobacionOrdenamiento: 0,
        fechaAprobacionOrdenamiento: null,
        idEstadoAprobacionCodigoBarras: 0,
        idUsuarioAprobacionCodigoBarras: 0,
        fechaAprobacionCodigoBarras: null,
        idEstadoProcesoCuentaCorriente: 0,
        idUsuarioProcesoCuentaCorriente: 0,
        fechaProcesoCuentaCorriente: null,
        idEstadoProcesoPublicacionDeuda: 0,
        idUsuarioProcesoPublicacionDeuda: 0,
        fechaProcesoPublicacionDeuda: null,
        idEstadoProcesoArchivoPublicacionDeuda: 0,
        idUsuarioProcesoArchivoPublicacionDeuda: null,
        fechaProcesoArchivoPublicacionDeuda: null,
        idEstadoProcesoImpresion: 0,
        idUsuarioProcesoImpresion: 0,
        fechaProcesoImpresion: null,
        idEstadoProcesoNotificacion: 0,
        idUsuarioProcesoNotificacion: 0,
        fechaProcesoNotificacion: null
    }

    const { hasPermission } = usePermissions();
    const canEditProceso = hasPermission(PERMISSIONS.PROCESO_EDIT);

    const processesPendingsRef = useRef(false);

    //hooks
    const [state, setState] = useState({
        emisionEjecucion: {
            id: 0,
            idEstadoEmisionEjecucion: 0,
            idEmisionDefinicion: 0,
            idOrdenamientoGeneral: 0,
            imprimeRecibosEmision: false
        },
        emisionDefinicion: {
            id: 0,
            idTipoTributo: 0,
            idBoletaDefinicion: 0
        },
        emisionEjecucionCuotas: [],
        disabled: false,
        loading: false,
        showMessage: false,
        textMessage: ''
    });
    const [operacion, setOperacion] = useState({
        action: '',
        async: false,
        data: null
    });
    const [aprobacion, setAprobacion] = useState(aprobaciontInit);
    const [procesos, setProcesos] = useState({
        procesoCuentaCorriente: procesoInit,
        procesoProrrogaVencimiento: procesoInit,
        procesoPublicacionDeuda: procesoInit,
        emisionPublicacionDeuda: procesoInit,
        procesoImpresion: procesoInit,
        emisionNotificacion: procesoInit
    });
    const [showProcesoModal, setShowProcesoModal] = useState(false);
    const [showProrrogaSeleccionModal, setShowProrrogaSeleccionModal] = useState(false);
    const [notificacionCuotas, setNotificacionCuotas] = useState(null);
    const [procesoEdit, setProcesoEdit] = useState(procesoInit);
    const [tiposProcesos, setTiposProcesos] = useState([]);
    
    const [historialProcesos, setHistorialProcesos] = useState([]);
    const [idTipoArchivoPublicacion, setIdTipoArchivoPublicacion] = useState(0);
    const [cuotaPublicacion, setCuotaPublicacion] = useState(0);

    const mount = () => {
        let myInterval = null;
        if (props.data) {
            setState(prevState => {
                return {
                    ...prevState,
                    emisionEjecucion: props.data.emisionEjecucion,
                    emisionDefinicion: props.data.emisionDefinicion,
                    emisionEjecucionCuotas: props.data.emisionEjecucionCuotas
                };
            });
            setTiposProcesos(props.data.tiposProcesos);

            if (props.data.emisionEjecucion.id > 0 && props.data.tiposProcesos.length > 0) {
                FindEmisionAprobacion(props.data.emisionEjecucion.id);
                SearchProcesos(props.data.emisionEjecucion.id);
                myInterval = setInterval(() => {
                    if (processesPendingsRef.current) {
                        SearchProcesos(props.data.emisionEjecucion.id);
                    }
                }, APPCONFIG.GENERAL.PROCESS_TIME_INTERVAL * 1000);
            }
        }

        return () => {
            if (myInterval) clearInterval(myInterval)
        };
    }
    useEffect(mount, [props.data.emisionEjecucion, props.data.tiposProcesos]);

    const [accessEmisionAprobacionEdit, setAccessEmisionAprobacionEdit] = useState(false);
    const [access, readyAceess] = useAccess({
        key: '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });
    useEffect(() => {
        if (readyAceess) {
            const emision_aprobacion_edit = access.some(f => f.codigo === 'emision-aprobacion_edit');
            setAccessEmisionAprobacionEdit(emision_aprobacion_edit);
        }
    }, [readyAceess]);

    useEffect(() => {
        if (!processesPendingsRef.current && props.countProcessPendings > 0) SearchProcesos(state.emisionEjecucion.id);
    }, [props.countProcessPendings]);

    const cuotasPublicacion = useMemo(() => {
        if (state.emisionEjecucion) {
            if (state.emisionEjecucion.calculoPagoAnticipado) {
                setCuotaPublicacion(state.emisionEjecucion.cuota);
                return [state.emisionEjecucion.cuota];
            } else {
                if (state.emisionEjecucionCuotas.length === 1)
                    setCuotaPublicacion(state.emisionEjecucionCuotas[0].cuota);
                else
                    setCuotaPublicacion(0);

                return state.emisionEjecucionCuotas.map(x => x.cuota);
            }
        } else {
            setCuotaPublicacion(0);
            return [];
        }
    }, [state.emisionEjecucion]);

    const [, getRowLista] = useLista({
        listas: ['EstadoProceso'],
        onLoaded: (listas, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'EstadoProceso',
            timeout: 0
        }
    });

    const getDescEstadoProceso = (props) => {
        const proceso = props.row.original;
        const abortando = [PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(proceso.idEstadoProceso) && proceso.cancelacionSolicitada;
        const row = getRowLista('EstadoProceso', proceso.idEstadoProceso);
        return (row && abortando && proceso.cancelable) ? `${row.nombre} (cancelando...)` :
               (row && abortando && proceso.pausable) ? `${row.nombre} (pausando...)` :
               (row) ? row.nombre : '';
    }

    const cellVMR = (data) => <div className='action'>
        <div onClick={(event) => {
            const row = data.row.original;
            setProcesoEdit(row);
            setShowProcesoModal(true);
        }}
             className="link"
        >
            <span className="material-symbols-outlined" title="Ver">search</span>
        </div>
    </div>

    const tableColumns = [
        {Header: 'Descripción', accessor: 'descripcion', width: '32%', disableSortBy: true},
        {
            Header: 'Estado',
            Cell: (props) => getDescEstadoProceso(props),
            accessor: 'idEstadoProceso',
            width: '12%',
            disableSortBy: true
        },
        {
            Header: 'Avance',
            Cell: (props) => <AvanceProceso avance={props.row.original.avance} idEstadoProceso={props.row.original.idEstadoProceso} />,
            csvValue: (row) => formatAvanceProceso(row.avance),
            accessor: 'avance',
            width: '12%',
            ellipsis: false
        },
        {
            Header: 'Prog.',
            Cell: (props) => getDateToString(props.value, true),
            accessor: 'fechaProceso',
            width: '14%',
            ellipsis: false
        },
        {
            Header: 'Inicio',
            Cell: (props) => getDateToString(props.value, true),
            accessor: 'fechaInicio',
            width: '14%',
            ellipsis: false
        },
        {
            Header: 'Fin',
            Cell: (props) => getDateToString(props.value, true),
            accessor: 'fechaFin',
            width: '14%',
            ellipsis: false
        },
        {
            Header: '',
            Cell: cellVMR,
            id: 'abm',
            accessor: 'identificador',
            width: '4%',
            disableGlobalFilter: true,
            disableSortBy: true,
            ellipsis: false
        }
    ];

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackNoSuccess_NoShow = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                // ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessSearchProcesos = (response) => {
        response.json()
            .then((data) => {

                data.sort((a,b) => b.id-a.id)

                data.forEach(row => {
                    if (row.fechaCreacion) row.fechaCreacion = new Date(row.fechaCreacion);
                    if (row.fechaProceso) row.fechaProceso = new Date(row.fechaProceso);
                    if (row.fechaInicio) row.fechaInicio = new Date(row.fechaInicio);
                    if (row.fechaFin) row.fechaFin = new Date(row.fechaFin);
                });

                let procesosNew = {
                    procesoCuentaCorriente: procesoInit,
                    procesoProrrogaVencimiento: procesoInit,
                    procesoPublicacionDeuda: procesoInit,
                    emisionPublicacionDeuda: procesoInit,
                    procesoImpresion: procesoInit,
                    emisionNotificacion: procesoInit
                }
                try {
                    //me quedo con el más reciente de cada grupo
                    const procesoCuentaCorriente = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'ProcesoCuentaCorriente').id).sort((a,b) => b.id-a.id);
                    if (procesoCuentaCorriente.length > 0) procesosNew.procesoCuentaCorriente = procesoCuentaCorriente[0];
                    const procesoProrrogaVencimiento = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'ProcesoProrrogaVencimiento').id).sort((a,b) => b.id-a.id);
                    if (procesoProrrogaVencimiento.length > 0) procesosNew.procesoProrrogaVencimiento = procesoProrrogaVencimiento[0];
                    const procesoPublicacionDeuda = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'ProcesoPublicacionDeuda').id).sort((a,b) => b.id-a.id);
                    if (procesoPublicacionDeuda.length > 0) procesosNew.procesoPublicacionDeuda = procesoPublicacionDeuda[0];
                    const emisionPublicacionDeuda = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'EmisionPublicacionDeuda').id).sort((a,b) => b.id-a.id);
                    if (emisionPublicacionDeuda.length > 0) procesosNew.emisionPublicacionDeuda = emisionPublicacionDeuda[0];
                    const procesoImpresion = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'ProcesoImpresion').id).sort((a,b) => b.id-a.id);
                    if (procesoImpresion.length > 0) procesosNew.procesoImpresion = procesoImpresion[0];
                    const emisionNotificacion = data.filter(f => f.idTipoProceso === tiposProcesos.find(f => f.codigo === 'EmisionNotificacion').id).sort((a,b) => b.id-a.id);
                    if (emisionNotificacion.length > 0) procesosNew.emisionNotificacion = emisionNotificacion[0];
                }
                catch (error) {
                    const message = 'Error consultando procesos 2: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                }

                const processesPendings = data.filter(f => [PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(f.idEstadoProceso));
                processesPendingsRef.current = (processesPendings.length > 0);

                setProcesos(procesosNew);
                setHistorialProcesos(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessFindEmisionAprobacion = (response) => {
        response.json()
            .then((data) => {
                if (data.fechaProcesoInformeCalculo) data.fechaProcesoInformeCalculo = new Date(data.fechaProcesoInformeCalculo);
                if (data.fechaProcesoControlRecibos) data.fechaProcesoControlRecibos = new Date(data.fechaProcesoControlRecibos);
                if (data.fechaAprobacionCalculo) data.fechaAprobacionCalculo = new Date(data.fechaAprobacionCalculo);
                if (data.fechaAprobacionControlRecibos) data.fechaAprobacionControlRecibos = new Date(data.fechaAprobacionControlRecibos);
                if (data.fechaProcesoOrdenamiento) data.fechaProcesoOrdenamiento = new Date(data.fechaProcesoOrdenamiento);
                if (data.fechaProcesoInformeOrdenamiento) data.fechaProcesoInformeOrdenamiento = new Date(data.fechaProcesoInformeOrdenamiento);
                if (data.fechaAprobacionOrdenamiento) data.fechaAprobacionOrdenamiento = new Date(data.fechaAprobacionOrdenamiento);
                if (data.fechaAprobacionCodigoBarras) data.fechaAprobacionCodigoBarras = new Date(data.fechaAprobacionCodigoBarras);
                if (data.fechaProcesoCuentaCorriente) data.fechaProcesoCuentaCorriente = new Date(data.fechaProcesoCuentaCorriente);
                if (data.fechaProcesoPublicacionDeuda) data.fechaProcesoPublicacionDeuda = new Date(data.fechaProcesoPublicacionDeuda);
                if (data.fechaProcesoArchivoPublicacionDeuda) data.fechaProcesoArchivoPublicacionDeuda = new Date(data.fechaProcesoArchivoPublicacionDeuda);
                if (data.fechaProcesoImpresion) data.fechaProcesoImpresion = new Date(data.fechaProcesoImpresion);
                if (data.fechaProcesoNotificacion) data.fechaProcesoNotificacion = new Date(data.fechaProcesoNotificacion);

                setAprobacion(data);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessModifyEmisionAprobacionAsync = (response) => {
        response.json()
            .then((data) => {
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Proceso iniciado...`);
                SearchProcesos(state.emisionEjecucion.id);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessModifyEmisionAprobacion = (response) => {
        if (props.onChange !== null) {
            props.onChange();
        }
        callbackSuccessFindEmisionAprobacion(response);
    }
    const callbackSuccessSearchNotificacionCuotas = (response) => {
        response.json()
            .then((data) => {
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                setNotificacionCuotas(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccesModifyCancelProceso = (response) => {
        response.json()
            .then((proceso) => {
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                if (proceso.cancelacionSolicitada && proceso.cancelable)
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Proceso de cancelación iniciado`);
                else if (proceso.cancelacionSolicitada && proceso.pausable)
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Proceso de pausa iniciado`);
                else
                    ShowToastMessage(ALERT_TYPE.ALERT_WARNING, `Proceso cancelado correctamente`);
                SearchProcesos(state.emisionEjecucion.id);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }

    //funciones
    function SearchProcesos(idEmisionEjecucion) {

        const paramsUrl = `/emision-ejecucion/${idEmisionEjecucion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PROCESO,
            paramsUrl,
            null,
            callbackSuccessSearchProcesos,
            callbackNoSuccess_NoShow,
            callbackError
        );

    }

    function FindEmisionAprobacion(idEmisionEjecucion) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/emision-ejecucion/${idEmisionEjecucion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_APROBACION,
            paramsUrl,
            null,
            callbackSuccessFindEmisionAprobacion,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchNotificacionCuotas(idEmisionEjecucion) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/notificacion-cuota/${idEmisionEjecucion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_APROBACION,
            paramsUrl,
            null,
            callbackSuccessSearchNotificacionCuotas,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyEmisionAprobacion(idEmisionAprobacion, fechaProceso = null) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl =   (operacion.async) ?
                                (fechaProceso) ? `/async/${idEmisionAprobacion}/${operacion.action}/${getDateSerialize(fechaProceso)}` :
                                `/async/${idEmisionAprobacion}/${operacion.action}` :
                            `/${idEmisionAprobacion}/${operacion.action}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EMISION_APROBACION,
            paramsUrl,
            operacion.data,
            (operacion.async) ? callbackSuccessModifyEmisionAprobacionAsync : callbackSuccessModifyEmisionAprobacion,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyCancelProceso(identificador) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/cancel/${identificador}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PROCESO,
            paramsUrl,
            null,
            callbackSuccesModifyCancelProceso,
            callbackNoSuccess,
            callbackError
        );

    }

    function EmisionAccion(fechaProceso = null) {
        ModifyEmisionAprobacion(aprobacion.id, fechaProceso);
        setState(prevState => {
            return {...prevState, showMessage: false, textMessage: ""};
        });
        setOperacion({action: "", async: false, data: null});
        setIdTipoArchivoPublicacion(0);
        if (cuotasPublicacion.length > 1) setCuotaPublicacion(0);
    }

    function NewProceso(descripcion) {
        let proceso = CloneObject(procesoInit);
        proceso.descripcion = descripcion;
        proceso.fechaProceso = getDateNow(true);
        setProcesoEdit(proceso);
        setShowProcesoModal(true);
    }

    //handles
    const handleProcesoCuentaCorriente = () => {
        setOperacion({action: "ProcesoCuentaCorriente", async: true, data: null});
        NewProceso("Aprobación de Cuenta Corriente");
    }
    const handleProcesoProrrogaVencimiento = (result) => {
        let data = { idEmisionEjecucionCuota: result.idEmisionEjecucionCuota };
        if (result.fechaVencimiento1Prorroga) data.fechaVencimiento1Prorroga = result.fechaVencimiento1Prorroga;
        if (result.fechaVencimiento2Prorroga) data.fechaVencimiento2Prorroga = result.fechaVencimiento2Prorroga;
        setOperacion({action: "ProcesoProrrogaVencimiento", async: true, data: data});
        NewProceso("Proceso de prorroga de vencimientos");
    }
    const handleProcesoPublicacionDeuda = () => {
        setOperacion({action: "ProcesoPublicacionDeuda", async: true, data: null});
        NewProceso("Proceso de publicación de deuda");
    }
    const handleEmisionPublicacionDeuda = () => {
        if (idTipoArchivoPublicacion === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar el tipo de archivo primero');
            return;
        }
        if (cuotaPublicacion === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar la cuota primero');
            return;
        }

        setState(prevState => {
            return {...prevState, showMessage: true, textMessage: "¿Está seguro/a de generar el/los archivo(s)?"};
        });
        setOperacion({
            action: "EmisionPublicacionDeuda",
            async: true,
            data: { idTipoArchivoPublicacion: idTipoArchivoPublicacion, cuotaPublicacion: cuotaPublicacion }
        });
    }
    const handleProcesoImpresion = () => {
        setOperacion({action: "ProcesoImpresion", async: true, data: null});
        NewProceso("Proceso de impresión");
    }
    const handleEmisionNotificacion = () => {
        // con varias cuotas el operador elige cuáles informa el aviso; con una, o con pago anticipado (un solo cupón con
        // todas), se notifica como siempre
        if (state.emisionEjecucionCuotas.length > 1 && !state.emisionEjecucion.calculoPagoAnticipado) {
            SearchNotificacionCuotas(state.emisionEjecucion.id);
            return;
        }
        setOperacion({action: "EmisionNotificacion", async: true, data: null});
        NewProceso("Proceso de notificaciones");
    }
    const handleNotificacionCuotas = (idsEmisionEjecucionCuota) => {
        setNotificacionCuotas(null);
        setOperacion({action: "EmisionNotificacion", async: true, data: { idsEmisionEjecucionCuota: idsEmisionEjecucionCuota }});
        NewProceso("Proceso de notificaciones");
    }


    return (
        <>

            <Loading visible={state.loading}></Loading>

            {state.showMessage &&
                <MessageModal
                    title={"Confirmación"}
                    message={state.textMessage}
                    onDismiss={() => {
                        setState(prevState => {
                            return {...prevState, showMessage: false, rowForm: null};
                        });
                    }}
                    onConfirm={() => {
                        setState(prevState => {
                            return {...prevState, showMessage: false};
                        });
                        EmisionAccion();
                    }}
                />
            }

            {showProcesoModal &&
                <ProcesoModal
                    proceso={procesoEdit}
                    onDismiss={() => {
                        setShowProcesoModal(false);
                    }}
                    onConfirm={(row) => {
                        setShowProcesoModal(false);
                        EmisionAccion(row.fechaProceso);
                    }}
                    onCancel={(row) => {
                        setShowProcesoModal(false);
                        ModifyCancelProceso(row.identificador);
                    }}
                    disabled={props.disabled || !canEditProceso}
                />
            }

            {(state.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA) &&
                <div className="m-top-20">
                    <Accordion title="Cuenta corriente">
                        <div className='row align-items-end'>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idEstadoProcesoCuentaCorriente" className="form-label">Estado</label>
                                <InputLista
                                    name="idEstadoProcesoCuentaCorriente"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idEstadoProcesoCuentaCorriente}
                                    lista="EstadoProceso"
                                    disabled={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idUsuarioProcesoCuentaCorriente" className="form-label">Usuario/a</label>
                                <InputEntidad
                                    name="idUsuarioProcesoCuentaCorriente"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idUsuarioProcesoCuentaCorriente}
                                    entidad="Usuario"
                                    disabled={true}
                                    onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="fechaProcesoCuentaCorriente" className="form-label">Fecha</label>
                                <DatePickerCustom
                                    name="fechaProcesoCuentaCorriente"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.fechaProcesoCuentaCorriente}
                                    disabled={true}
                                    time={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-3 align-items-center display-row">
                            {(!props.disabled && accessEmisionAprobacionEdit && aprobacion.idEstadoProcesoCuentaCorriente === PROCESO_STATE.PENDIENTE &&
                                                                                aprobacion.idEstadoAprobacionCodigoBarras === APROBACION_STATE.APROBADO) &&
                            <>
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoCuentaCorriente.idEstadoProceso)}
                                    className="btn action-button" data-dismiss="modal"
                                    onClick={(event) => handleProcesoCuentaCorriente()}>
                                    Procesar
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.procesoCuentaCorriente}
                                    onFinish={() => {
                                        FindEmisionAprobacion(state.emisionEjecucion.id);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                            </>
                            }
                            {(!props.disabled && accessEmisionAprobacionEdit && aprobacion.idEstadoProcesoCuentaCorriente === PROCESO_STATE.FINALIZADO) &&
                            <>
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoProrrogaVencimiento.idEstadoProceso)}
                                    className="btn back-button" data-dismiss="modal"
                                    onClick={(event) => setShowProrrogaSeleccionModal(true)}>
                                    Prorroga de vencimientos
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.procesoProrrogaVencimiento}
                                    onFinish={() => {
                                        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Prorroga de vencimientos generada exitosamente.`);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                                {showProrrogaSeleccionModal &&
                                    <ProrrogaSeleccionModal
                                        data={{
                                            periodo: state.emisionEjecucion.periodo,
                                            cuotas: state.emisionEjecucionCuotas
                                        }}
                                        onConfirm={(result) => {
                                            setShowProrrogaSeleccionModal(false);
                                            handleProcesoProrrogaVencimiento(result);
                                        }}
                                        onDismiss={() => {
                                            setShowProrrogaSeleccionModal(false);
                                        }}
                                    />
                                }
                            </>
                            }
                            </div>
                        </div>
                    </Accordion>
                </div>
            }

            {(state.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA && state.emisionEjecucion.imprimeRecibosEmision) &&
                <div className="m-top-20">
                    <Accordion title="Publicación de deuda">
                        <div className='row align-items-end'>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idEstadoProcesoPublicacionDeuda" className="form-label">Estado de Pub. a Tesorería</label>
                                <InputLista
                                    name="idEstadoProcesoPublicacionDeuda"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idEstadoProcesoPublicacionDeuda}
                                    lista="EstadoProceso"
                                    disabled={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idUsuarioProcesoPublicacionDeuda" className="form-label">Usuario/a</label>
                                <InputEntidad
                                    name="idUsuarioProcesoPublicacionDeuda"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idUsuarioProcesoPublicacionDeuda}
                                    entidad="Usuario"
                                    disabled={true}
                                    onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="fechaProcesoPublicacionDeuda" className="form-label">Fecha</label>
                                <DatePickerCustom
                                    name="fechaProcesoPublicacionDeuda"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.fechaProcesoPublicacionDeuda}
                                    disabled={true}
                                    time={true}
                                />
                            </div>
                            {(!props.disabled && aprobacion.idEstadoProcesoPublicacionDeuda === PROCESO_STATE.PENDIENTE &&
                                                 aprobacion.idEstadoProcesoCuentaCorriente === PROCESO_STATE.FINALIZADO) &&
                            <div className="mb-3 col-12 col-md-6 col-lg-3 align-items-center display-row">
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoPublicacionDeuda.idEstadoProceso)}
                                    className="btn action-button" data-dismiss="modal"
                                    onClick={(event) => handleProcesoPublicacionDeuda()}>
                                    Publicar
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.procesoPublicacionDeuda}
                                    onFinish={() => {
                                        FindEmisionAprobacion(state.emisionEjecucion.id);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                            </div>
                            }
                        </div>
                        {(!props.disabled && aprobacion.idEstadoProcesoPublicacionDeuda === PROCESO_STATE.FINALIZADO) &&
                        <div className='row align-items-end ' >
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idEstadoProcesoArchivoPublicacionDeuda" className="form-label">Estado de Pub. a Entes Rec.</label>
                                <InputLista
                                    name="idEstadoProcesoArchivoPublicacionDeuda"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idEstadoProcesoArchivoPublicacionDeuda}
                                    lista="EstadoProceso"
                                    disabled={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idUsuarioProcesoArchivoPublicacionDeuda" className="form-label">Usuario/a</label>
                                <InputEntidad
                                    name="idUsuarioProcesoArchivoPublicacionDeuda"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idUsuarioProcesoArchivoPublicacionDeuda}
                                    entidad="Usuario"
                                    disabled={true}
                                    onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="fechaProcesoArchivoPublicacionDeuda" className="form-label">Fecha</label>
                                <DatePickerCustom
                                    name="fechaProcesoArchivoPublicacionDeuda"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.fechaProcesoArchivoPublicacionDeuda}
                                    disabled={true}
                                    time={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idTipoArchivoPublicacion" className="form-label">Tipo de archivo</label>
                                <InputLista
                                    name="idTipoArchivoPublicacion"
                                    placeholder=""
                                    className="form-control"
                                    value={idTipoArchivoPublicacion}
                                    lista="TipoArchivoPublicacion"
                                    onChange={({target}) => {
                                        setIdTipoArchivoPublicacion(target.value);
                                    }}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="cuotaPublicacion" className="form-label">Cuota</label>
                                <Select
                                    name="cuotaPublicacion"
                                    className="form-control"
                                    value={cuotaPublicacion}
                                    options={cuotasPublicacion.map(cuota => ({value: cuota, label: cuota}))}
                                    emptyOption="Sin selección"
                                    emptyValue={0}
                                    disabled={(cuotasPublicacion.length <= 1)}
                                    onChange={({target}) => setCuotaPublicacion(target.value)}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2 align-items-center display-row">
                                <button
                                    disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.emisionPublicacionDeuda.idEstadoProceso)}
                                    className="btn back-button" data-dismiss="modal"
                                    onClick={(event) => handleEmisionPublicacionDeuda()}>
                                    Generar
                                </button>
                                <ProcessLoading
                                    className="m-left-5"
                                    proceso={procesos.emisionPublicacionDeuda}
                                    onFinish={() => {
                                        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Archivo(s) generado(s) exitosamente. Podrá descargar el/los archivo(s) en la sección de "información adicional"`);
                                        if (props.onChange !== null) {
                                            props.onChange();
                                        }
                                    }}
                                    onClick={(row) => {
                                        setProcesoEdit(row);
                                        setShowProcesoModal(true);
                                    }}
                                    showFinalizado={true}
                                />
                            </div>
                        </div>
                        }
                    </Accordion>
                </div>
            }

            {(state.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA && state.emisionEjecucion.imprimeRecibosEmision &&
                                                                                                       (state.emisionDefinicion.idBoletaDefinicion??0) > 0) &&
                <div className='m-top-20'>
                    <Accordion title="Impresión de boletas">
                        <div className='row align-items-end'>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idEstadoProcesoImpresion" className="form-label">Estado</label>
                                <InputLista
                                    name="idEstadoProcesoImpresion"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idEstadoProcesoImpresion}
                                    lista="EstadoProceso"
                                    disabled={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idUsuarioProcesoImpresion" className="form-label">Usuario/a</label>
                                <InputEntidad
                                    name="idUsuarioProcesoImpresion"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idUsuarioProcesoImpresion}
                                    entidad="Usuario"
                                    disabled={true}
                                    onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="fechaProcesoImpresion" className="form-label">Fecha</label>
                                <DatePickerCustom
                                    name="fechaProcesoImpresion"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.fechaProcesoImpresion}
                                    disabled={true}
                                    time={true}
                                />
                            </div>
                            {(!props.disabled && aprobacion.idEstadoProcesoPublicacionDeuda === PROCESO_STATE.FINALIZADO) &&
                                <div className="mb-3 col-12 col-md-6 col-lg-3 align-items-center display-row">
                                    <button
                                        disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.procesoImpresion.idEstadoProceso)}
                                        className="btn action-button" data-dismiss="modal"
                                        onClick={(event) => handleProcesoImpresion()}>
                                        Generar archivos
                                    </button>
                                    <ProcessLoading
                                        className="m-left-5"
                                        proceso={procesos.procesoImpresion}
                                        onFinish={() => {
                                            FindEmisionAprobacion(state.emisionEjecucion.id);
                                            if (props.onChange !== null) {
                                                props.onChange();
                                            }
                                        }}
                                        onClick={(row) => {
                                            setProcesoEdit(row);
                                            setShowProcesoModal(true);
                                        }}
                                        showFinalizado={true}
                                    />
                                </div>
                            }
                        </div>
                    </Accordion>
                </div>
            }

            {(state.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA && state.emisionEjecucion.imprimeRecibosEmision) &&
                <div className='m-top-20'>
                    <Accordion title="Notificaciones">
                        <div className='row align-items-end'>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idEstadoProcesoNotificacion" className="form-label">Estado</label>
                                <InputLista
                                    name="idEstadoProcesoNotificacion"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idEstadoProcesoNotificacion}
                                    lista="EstadoProceso"
                                    disabled={true}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="idUsuarioProcesoNotificacion" className="form-label">Usuario/a</label>
                                <InputEntidad
                                    name="idUsuarioProcesoNotificacion"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.idUsuarioProcesoNotificacion}
                                    entidad="Usuario"
                                    disabled={true}
                                    onFormat={(row) => (row && row.id) ? row.nombreApellido : ''}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                <label htmlFor="fechaProcesoNotificacion" className="form-label">Fecha</label>
                                <DatePickerCustom
                                    name="fechaProcesoNotificacion"
                                    placeholder=""
                                    className="form-control"
                                    value={aprobacion.fechaProcesoNotificacion}
                                    disabled={true}
                                    time={true}
                                />
                            </div>
                            {(!props.disabled && aprobacion.idEstadoProcesoPublicacionDeuda === PROCESO_STATE.FINALIZADO) &&
                                <div className="mb-3 col-12 col-md-6 col-lg-3 align-items-center display-row">
                                    <button
                                        disabled={[PROCESO_STATE.PENDIENTE, PROCESO_STATE.PROGRESO].includes(procesos.emisionNotificacion.idEstadoProceso)}
                                        className="btn action-button" data-dismiss="modal"
                                        onClick={(event) => handleEmisionNotificacion()}>
                                        Envío de notificaciones
                                    </button>
                                    <ProcessLoading
                                        className="m-left-5"
                                        proceso={procesos.emisionNotificacion}
                                        onFinish={() => {
                                            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `Notificaciones enviadas exitosamente.`);
                                            if (props.onChange !== null) {
                                                props.onChange();
                                            }
                                        }}
                                        onClick={(row) => {
                                            setProcesoEdit(row);
                                            setShowProcesoModal(true);
                                        }}
                                        showFinalizado={true}
                                    />
                                    {notificacionCuotas &&
                                        <NotificacionSeleccionModal
                                            data={{
                                                periodo: state.emisionEjecucion.periodo,
                                                cuotas: state.emisionEjecucionCuotas,
                                                notificaciones: notificacionCuotas
                                            }}
                                            onConfirm={(result) => handleNotificacionCuotas(result)}
                                            onDismiss={() => setNotificacionCuotas(null)}
                                        />
                                    }
                                </div>
                            }
                        </div>
                    </Accordion>
                </div>
            }

            <div className='m-top-20'>
                <Accordion title="Historial de procesos" startOpen={true}>
                    <TableCustom
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumns}
                        data={historialProcesos}
                    />
                </Accordion>
            </div>

        </>
    );
}

EmisionProcesosGrid.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onChange: func,
    countProcessPendings: number
};

EmisionProcesosGrid.defaultProps = {
    disabled: false,
    onChange: null,
    countProcessPendings: 0
};

export default EmisionProcesosGrid;